var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartialCloudyFilled = function SvgPartialCloudyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.5 1.5a1 1 0 1 0-2 0v1.6a1 1 0 1 0 2 0zM2 9a1 1 0 1 0 0 2h1.6a1 1 0 1 0 0-2zM3.613 3.113a1 1 0 0 1 1.414 0l1.131 1.131a1 1 0 1 1-1.414 1.414L3.613 4.527a1 1 0 0 1 0-1.414M17.388 4.527a1 1 0 0 0-1.414-1.414l-1.131 1.131a1 1 0 0 0 1.414 1.414zM16.4 10a1 1 0 0 1 1-1H19a1 1 0 1 1 0 2h-1.6a1 1 0 0 1-1-1M7.5 10a3 3 0 0 1 5.626-1.453 1 1 0 0 0 1.749-.97A5 5 0 0 0 5.5 10a1 1 0 1 0 2 0M12 10a6 6 0 0 0-5.23 3.059A5 5 0 1 0 6 23h12a5 5 0 1 0-.77-9.941A6 6 0 0 0 12 10"
  })));
};
export default SvgPartialCloudyFilled;